import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "flex justify-between w-full gap-4" };
import _ from "lodash";
import moment from "moment";
import { computed } from "vue";
import { useStore } from "vuex";
import ProjectMainInfoImage from "@/components/uikit/platformComponents/project/ProjectMainInfoImage.vue";
import UDivider from "@/components/uikit/uComponents/UDivider.vue";
import UList from "@/components/uikit/uComponents/UList.vue";
import UListItem from "@/components/uikit/uComponents/UListItem.vue";
import UMap from "@/components/uikit/uComponents/UMap.vue";
import UMarkdownViewer from "@/components/uikit/uComponents/UMarkdownViewer.vue";
import { getIsAutenticProject } from "@/components/capital/projectHelper";
import { useI18n } from "@/localization/localizator";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectMainInfo',
    setup(__props) {
        const t = useI18n();
        const store = useStore();
        const project = computed(() => store.getters["capitals/auCapital"]);
        const countryOptions = computed(() => _.map(store.getters.country, (c) => ({ display: c.name, value: c.code })));
        const country = computed(() => _.chain(countryOptions.value)
            .find({ value: project.value.company?.countryCode })
            .get("display")
            .value());
        const countryInfo = computed(() => country.value ? country.value : t("auCapitals.projectCard.notSet"));
        const companyInfo = computed(() => project.value.company
            ? project.value.company.nameEng
            : t("auCapitals.projectCard.notSet"));
        function formatDate(date) {
            return moment(date).format("DD.MM.YYYY  HH:mm");
        }
        const isAutenticProject = computed(() => {
            return getIsAutenticProject(project.value);
        });
        const infoForInvest = computed(() => [
            [
                {
                    label: t("auCapitals.projectCard.information.country"),
                    value: countryInfo.value,
                    styleType: "greyLabel"
                },
                {
                    label: t("auCapitals.projectCard.information.SPV"),
                    value: isAutenticProject.value
                        ? t("auCapitals.projectCard.information.LLC")
                        : companyInfo.value,
                    styleType: "greyLabel"
                },
                {
                    label: t("auCapitals.projectCard.information.openDate"),
                    value: formatDate(project.value.dateStart),
                    styleType: "greyLabel"
                },
                {
                    label: t("auCapitals.projectCard.information.closeDate"),
                    value: formatDate(project.value.dateEnd),
                    styleType: "greyLabel"
                }
            ],
            [
                {
                    label: t("auCapitals.projectCard.information.dividends"),
                    value: "true",
                    type: "boolean",
                    styleType: "greyLabel"
                },
                {
                    label: t("auCapitals.projectCard.information.equity"),
                    value: "true",
                    type: "boolean",
                    styleType: "greyLabel"
                },
                {
                    label: t("auCapitals.projectCard.information.votingRight"),
                    value: "true",
                    type: "boolean",
                    styleType: "greyLabel"
                },
                {
                    label: t("auCapitals.projectCard.information.specialConditions"),
                    value: "false",
                    type: "boolean",
                    styleType: "greyLabel"
                }
            ]
        ]);
        const items = infoForInvest;
        return (_ctx, _cache) => {
            const _component_UContent = _resolveComponent("UContent");
            return (_openBlock(), _createBlock(_component_UContent, null, {
                default: _withCtx(() => [
                    _createVNode(ProjectMainInfoImage),
                    _createVNode(_component_UContent, {
                        "has-title-delimiter": false,
                        "has-padding": false
                    }, {
                        "header-left": _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createTextVNode(" About ", -1)
                            ]))]),
                        default: _withCtx(() => [
                            _createVNode(UMarkdownViewer, {
                                content: project.value.descriptionEng
                            }, null, 8, ["content"])
                        ]),
                        _: 1
                    }),
                    _createVNode(UDivider),
                    _createVNode(_component_UContent, {
                        "has-title-delimiter": false,
                        "has-padding": false
                    }, {
                        "header-left": _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createTextVNode(" Information ", -1)
                            ]))]),
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (row, rowIndex) => {
                                    return (_openBlock(), _createBlock(UList, {
                                        key: rowIndex,
                                        gap: "10px",
                                        class: "w-full"
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (item, index) => {
                                                return (_openBlock(), _createBlock(UListItem, _mergeProps({ key: index }, { ref_for: true }, item), null, 16));
                                            }), 128))
                                        ]),
                                        _: 2
                                    }, 1024));
                                }), 128))
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(UDivider),
                    _createVNode(_component_UContent, {
                        "has-title-delimiter": false,
                        "has-padding": false
                    }, {
                        "header-left": _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode(" Location ", -1)
                            ]))]),
                        default: _withCtx(() => [
                            _createVNode(UMap, {
                                address: project.value.address
                            }, null, 8, ["address"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
